// PACKAGES
import { createStore, combineReducers, compose } from 'redux';
import qs from 'qs';
// SETUP
import { loadState, saveState } from './localStorage';
import { createBrowserHistory, createMemoryHistory } from 'history';
import reducers from './reducers';
// COMPONENTS
import userConfirm from 'components/Confirm';

const persistedState = loadState();
const history = process.env.NODE_ENV === 'test'
    ? createMemoryHistory({
        getUserConfirmation: null,
    })
    : createBrowserHistory({
        getUserConfirmation: async (message, callback) => {
            try {
                await userConfirm({ message, theme: 'confirm', callback });
            }
            catch (error) {
                console.error(error);
            }
        },
    });

history.params = (param = null) => {
    const obj = qs.parse(history.location.search.replace('?', ''));
    if (param) {
        return obj[param];
    }

    return obj;
};

const store = createStore(
    combineReducers({
        ...reducers,
    }),
    persistedState,
    compose(
        ...[
            /* istanbul ignore next */
            window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
        ].filter(i => i !== undefined)
    ),
);

store.subscribe(() => {
    saveState(store.getState());
});

const syncAuth = () => {
    try {
        const state = loadState();
        if (state?.auth) {
            const currentAuth = store.getState().auth;
            const hasAuthChanged = state.auth.access_token !== currentAuth.access_token ||
                                 state.auth.refresh_token !== currentAuth.refresh_token ||
                                 state.auth.isRefreshing !== currentAuth.isRefreshing;

            if (hasAuthChanged) {
                store.dispatch({ type: 'UPDATE_USER', ...state.auth });
                return state.auth;
            }
        }
    }
    catch (error) {
        console.error('Failed to sync auth from localStorage', error);
    }
    return null;
};

window.addEventListener('storage', (e) => {
    if (e.key === 'state' && e.newValue) {
        syncAuth();
    }
});

export { store, history, syncAuth };
